/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReceivablesPayablesModel { 
    storeId: number;
    uin: string;
    title: string;
    payable: number;
    receivable: number;
    balance: number;
}

